{"accountSettings":"Kontoeinstellungen","addReasonCodes":"Ablehnungsgrund hinzufügen","notifications":"Benachrichtigungen","callHistory":"Anrufverlauf"}